export const HOMEPAGE_PATH = '/';
export const RENTAL_PAGE_PATH = '/fuzebox';
export const SUCCESS_PAGE_PATH = '/success';
export const WELCOME_BACK_PAGE_PATH = '/welcome-back';
export const BAD_STATION_STATUS_PAGE_PATH = '/station/status';
